import { Range } from 'slate';

import { unwrapNodes } from '../../../../../slatePlugins/transforms/unwrapNodes';
import { isInsideOfElement } from '../../../helpers/selection';
import { wrapBlockAtSelection } from '../../../helpers/toggleBlockAtSelection';
import { ELEMENT_HYPER_LINK } from '../defaults';
import { HyperLink } from '../types';
import { getWrapLinkRange } from './getWrapLinkRange';

const isLinkActive = (editor) => isInsideOfElement(editor, ELEMENT_HYPER_LINK);

export const unwrapLink = (editor) => {
  unwrapNodes(editor, {
    match: { type: ELEMENT_HYPER_LINK } as any,
  });
};

export const wrapLink = (editor, hyperLink: HyperLink) => {
  if (isLinkActive(editor)) {
    unwrapLink(editor);
  }

  const at = getWrapLinkRange(editor, editor.selection);
  if (at) {
    wrapBlockAtSelection(
      editor,
      ELEMENT_HYPER_LINK,
      {
        ...hyperLink,
        children: Range.isCollapsed(editor.selection) ? [{ text: hyperLink.url }] : [],
      },
      {
        at,
      }
    );
  }
};

export const insertLink = (editor, hyperLink: HyperLink) => {
  if (editor.selection) {
    wrapLink(editor, hyperLink);
  }
};
